var option_webview_default = {
  "option": "z5z2h",
  "user_choice": "PWvQy",
  "check": "Ljsob",
  "image": "_0x-mK",
  "input": "vPyKs",
  "title": "_6d8Ac",
  "centered": "no1wC",
  "with_result": "_8TqdU",
  "list": "-q-iJ",
  "with_image": "NVfIa",
  "progress": "-zu86",
  "progress_value": "yq4Ll",
  "label": "vEMzn",
  "cta": "eixhe",
  "adornment_icon": "aal97",
  "remove": "IvSdO",
  "removeButton": "E20Jb",
  "removeButtonIcon": "UZid9",
  "overlay": "FcGLZ",
  "shown": "fHJ4g",
  "dark": "VvJ-C",
  "spinner": "Mr3te",
  "spin": "kZDtU",
  "grid": "bMQap"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
